import script from "./NotePublicView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotePublicView.vue?vue&type=script&setup=true&lang=js"

import "./NotePublicView.vue?vue&type=style&index=0&id=5ef1d96d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef1d96d"]])

export default __exports__